export default __webpack_public_path__ + "assets/images/8cbc0d3a7bf681903db9c39505300dc8.svg";